import { STORE_ACTION, STORE_COMMIT, STORE_GETTER } from "../store/store"

import categoryHelper from "../helper/category-helper";

import listHelper from "@/helper/list-helper.js";
import searchUtil from "../store/store-search-utils";

export const productSearchMixin = {
	

	data() {
		return {
			backspaceSearchTimer: null
		}
	},

	computed: {

		model() {

			const model = {};

			var productList = [];

			const model2 = this.searchProductConfig.model2;

			// om det är en productGroup vald
			if (this.productGroup && this.productGroup.key != null){

				var productIdList = this.productGroup.productIdList

				if (this.productGroup.desc){
					productIdList = productIdList?.filter(productId => productId != null).reverse();
				}

				productIdList?.forEach(productId => {

					if (productId !== null) {

						const product = this.$store.state.productStore.data.productList[productId];
						if (product){
							productList.push(product);	
						}
						
					}

				});

				// FP: 2026 skapar en lista att visa under tiden sök-index byggs upp. 
			/*} else if (this.$store.state.productStore.data.productList?.length > 1000 && model2.totalCount == 0){
				
				//alert("ok");

				this.$store.state.productStore.data.productList?.filter(product => product !== null).reverse().forEach(product => {

					if (product) {
						productList.push(product);
					}

				});*/
				

			}else{ 

				

				
				// om det inte är produktgrupp vald
				model.totalCount = model2.totalCount;

				productList = model2.productList;

				

			}

			// exkludera från resultatet, finns även i store.js
			productList = productList.filter(product => !searchUtil.excludeProductFromResult(product, this.searchProductConfig))



			
			model.productListSearch = model2.productListSearch



			if (this.searchProductConfig && this.searchProductConfig.sort) {
				//alert("sort:" + this.searchProductConfig.sort.property + " desc: " + this.searchProductConfig.sort.desc);



				productList = listHelper.sortList(productList, this.searchProductConfig.sort.property, this.searchProductConfig.sort.desc);
			}

			model.resultCount = productList.length;
			model.productListUntrimmed = productList;
			model.productList = listHelper.trimToLimit(productList, this.tableConfig.scrollLimit);
			
			

			

			return model;

		},

		modelProductList(){
			return this.model?.productList;
		},


		groupedProductListModel() {

			const productList = this.model?.productListUntrimmed;

			var groupedProductMap = new Map();

			const manufactorListAll = this.$store.getters[STORE_GETTER.MANUFACTOR_LIST_ALL];
			console.log('FP: manufactorList', manufactorList);
			

			var manufactorList = [];

			// loopa produkterna 
			productList?.forEach(product => {

				if (product != null){

					const manufactorId = product.manufactorId;

					if (!manufactorList[manufactorId]){
						const manufactor = manufactorListAll?.find(manufactor => manufactor != null && manufactor.manufactorId == manufactorId)
						manufactorList[manufactorId] = manufactor;

					}

					if (!groupedProductMap.has(manufactorId)) {
						groupedProductMap.set(manufactorId, []);
					}

					const productList = groupedProductMap.get(manufactorId);
					productList.push(product);
				}

			})

			var model = {};

			// sortera manufactorList 
			manufactorList = manufactorList?.filter(manufactor => manufactor != null)?.sort((a, b) => a.name.localeCompare(b.name, 'sv'));

			model.manufactorList = manufactorList?.filter(manufactor => manufactor != null);
			model.groupedProductMap = groupedProductMap

			console.log('FP: groupedProductListModel manufactorList', manufactorList);
			

			return model;
			//return Array.from(groupedProductMap.values());
			//return groupedProductMap;
		},

		/*productList5(){ // FP: Döp om denna

			if (!this.productGroup  || this.productGroup.key == null){
				return this.model.productList;
			}

			var productList = [];

			const productIdList = this.productGroup.productIdList

			console.log('FP: productList5: ', productList);

			productIdList?.forEach(productId => {

					if (productId !== null) {

						const product = this.$store.state.productStore.data.productList[productId];
						productList.push(product);
					}
				});

			console.log('FP: productList5: ', productList);

			if (this.searchProductConfig && this.searchProductConfig.sort) {
				productList = listHelper.sortList(productList, this.searchProductConfig.sort.property, this.searchProductConfig.sort.desc);
			}


			//productList = listHelper.trimToLimit(productList, this.tableConfig.scrollLimit);
				
				return productList;


		}*/


		tableConfig() {
			//const tableConfig = this.$store.getters[STORE_GETTER.TABLE_CONFIGS].find((tableConfig) => { return tableConfig.key == "testProductList" });

			const tableConfig = this.$store.getters[STORE_GETTER.TABLE_CONFIGS].find(tableConfig => tableConfig.key == this.tableConfigKey)
			console.log('FP: found tableConfig: ', tableConfig);


			if (tableConfig) {
				return tableConfig;
			}

			return { key: this.tableConfigKey, defaultScrollLimit: 50, scrollLimit: 50, append: 50, filter: "", sort: "", desc: true } // defaultvärden
		},

		searchModel() {
			return this.$store.getters[STORE_GETTER.SEARCH_MODEL];

			//return searchModel.productList.filter(item => item !== null);
		},

		searchProductResult() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_RESULT];
		},

		searchProductConfig() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},

		productSearchEnabled(){
			return this.$store.getters[STORE_GETTER.PRODUCT_SEARCH_ENABLED];
		}


		

	},

	methods: {

		triggerFilterInputSearch(newFilter) { 

			

			if (this.searchProductConfig.popoverOpen) {
				this.showPageMenu('menuSearch');
				this.searchProductConfig.popoverOpen = false
			}
			const searchProductConfig = this.searchProductConfig
			searchProductConfig.searchPhrase = newFilter
			this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)
			this.triggerSearch()

		},
		triggerSearch() {


			if (this.spinning) {
				console.log('FP: SÖK: skip search');

				return;
			}

			this.spinning = true;

			console.log('FP: SÖK: Start search');

			this.$store.dispatch({ type: STORE_ACTION.SEARCH_PRODUCT_A, data: { productList: this.searchModel.productList } }).then(result => {
				console.log('FP: SÖK: Done: ', result);
				this.spinning = false;



				if (result.currentSearchPhrase != null && result.currentSearchPhrase != "" && result.currentSearchPhrase != this.searchProductConfig.searchPhrase) {


					this.triggerSearch()
					//alert("re-search");
				} else {
					//this.searching = false;
					this.createModel()
				}

				//alert("OK");



			}).finally(() => {
				//alert("ok")
				console.log('FP: search done');
			})


		},

		enterPressed() {


			const searchProductConfig = this.searchProductConfig

			searchProductConfig.searchPhrase = this.filterInput

			this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)

			this.triggerSearch()
			
		},

		filterInputChanged(newFilter, oldFilter) {
			
			if (newFilter == "-") { // för att kunna sätta mc

				const searchProductConfig = this.searchProductConfig
				searchProductConfig.searchPhrase = ''

				this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)

				this.filterInput = '' // FP: skapar att watchen triggas igen men fångas upp längre ned. 

				return;
			}

			if (!this.autoSearch) {
				const searchProductConfig = this.searchProductConfig
				searchProductConfig.searchPhrase = newFilter
				this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)
				return;
			}



			if (newFilter.length == 0 && oldFilter.length > 0 && oldFilter != "-") {
				//alert("trigger 1:" + newFilter + " old: " + oldFilter)
				this.triggerFilterInputSearch("");
			}

			if (newFilter.length == 0) {
				console.log("FP: watcher: filter input == 0");
				return;

			}

			if (newFilter.length < 3) {
				console.log("FP: watcher: filter input < 3");
				return;

			}

			if (oldFilter.includes(newFilter) && !newFilter.endsWith(" ")) { // om man suddar, men inte om man suddar klart ett ord
				console.log('FP: watcher: sudda: ' + newFilter + ".");

				// triggar alltid en sökning om man suddar
				clearTimeout(this.backspaceSearchTimer)

				this.backspaceSearchTimer = setTimeout(() => {
					this.triggerFilterInputSearch(newFilter);
				}, 2000)

				return;

			}

			// om sista ordet är längre än 2 tecken. 
			const last = newFilter.split(" ").slice(-1)[0]

			if (last.length < 3) {
				console.log('FP: watcher last < 3 ', last);
				return;
			}

			if (newFilter.endsWith(" ")) {
				console.log("FP: watcher: slutar med space");
			}


			console.log('FP: SÖK watcher: ', newFilter);
			this.triggerFilterInputSearch(newFilter);

		},

		createModel(){
			this.$store.commit(STORE_COMMIT.CREATE_MODEL);
		},

		createModel_OLD() {

			console.log('FP: search: model-computed');


			var model = { totalCount: 0, resultCount: 0, productList: [], productListSearch: [] };

			//model.type = "config"
			if (this.searchProductConfig.productList) {
				model.totalCount = this.searchProductConfig.productList.length
			} else {
				model.totalCount = 0;
			}

			var productList = [];

			// hämta ut träffar, bygg 
			this.searchProductResult.productList.filter(entity => entity !== null).forEach(entity => {
				const product = this.$store.state.productStore.data.productList[entity.entityId];

				if (product){
					if (entity.search && entity.search.totalScore > 0) {
						product.score = entity.search.totalScore
					} else {
						product.score = 0;
					}

					product.entity = entity
					productList.push(product)
				}
			
			})


			// skapa en lista till search
			model.productListSearch = productList.filter(product => product != null).sort((a, b) => b.score - a.score).slice(0, 12);

			// sortera på bäst score, lägg till flera sorts

			//productList = productList.sort((a, b) => b.score - a.score)

			model.totalCount = productList.length


			model.resultCount = productList.length;

			// sortera på kolumner
			//productList = listHelper.sortList(productList, this.tableConfig.sort, this.tableConfig.desc);
			//if (this.searchProductConfig && this.searchProductConfig.sort) {
			//	productList = listHelper.sortList(productList, this.searchProductConfig.sort.property, this.searchProductConfig.sort.desc);
			//}


			//model.resultCount = productList.length;

			// trimma till rätt längd
			//productList = listHelper.trimToLimit(productList, this.tableConfig.scrollLimit);

			model.productList = productList;

			console.log('FP: search model: ', model);

			//this.model2 = model;

			this.searchProductConfig.model2 = model; // här lägger vi in modellen som modell 2 på objektet i store. 



			//return model;



		},

		searchMcSelected(mc) {

			console.log('FP: mc: ', mc);

			if (this.baseMcTree) {
				const brand = this.baseMcTree.find(brand => brand.id == mc.brandId);
				this.searchProductConfig.brand = brand;
				this.searchProductConfig.mc = mc;
				this.searchProductConfig.year = null;
			}

			this.searchProductConfig.manufactor = null;
			this.searchProductConfig.category = null;

			this.searchProductConfig.searchPhrase = '';
			this.searchProductConfig.productGroupKey = null
			this.filterInput = '-';

			

			this.hideAllPageMenu()
			this.showProductList()

		},

		searchMcSelectedWithoutNavigation(mc) {

			console.log('FP: mc: ', mc);

			if (this.baseMcTree) {
				const brand = this.baseMcTree.find(brand => brand.id == mc.brandId);
				this.searchProductConfig.brand = brand;
				this.searchProductConfig.mc = mc;
				this.searchProductConfig.year = null;
			}

			this.searchProductConfig.manufactor = null;
			this.searchProductConfig.category = null;

			this.searchProductConfig.searchPhrase = '';
			this.searchProductConfig.productGroupKey = null
			this.filterInput = '-';

			//this.hideAllPageMenu()
			//this.showProductList()

		},




		searchCategorySelected(category) {

			// FP: TODO kolla igenom denna lite mer. 

			//alert("searchCategorySelected");

			//const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			// const categoryTree = baseModel.categoryModel.categoryTree;
			const categoryTree = this.$store.getters[STORE_GETTER.CATEGORY_MODEL]?.categoryTree;

			//const categoryNode = categoryHelper.findNode(category.categoryId, { categoryId: -1, categoryList: categoryTree });
			const categoryNode = categoryHelper.findNode(category.categoryId, categoryTree); // FP-CT

			console.log('FP: category: searchCategorySelected', categoryNode);

			if (!category) {
				console.log('FP: searchCategorySelected hittade ingen category, ', category);

				return;
			}

			this.searchProductConfig.brand = null;
			this.searchProductConfig.mc = null;
			this.searchProductConfig.year = null;

			this.searchProductConfig.manufactor = null;
			this.searchProductConfig.category = categoryNode;

			this.searchProductConfig.searchPhrase = '';
			this.searchProductConfig.productGroupKey = null
			this.filterInput = '-';

			this.hideAllPageMenu()
			this.showProductList()
		},

		searchCategorySelectedWithoutNavigation(category) { // FP: SE OVAN

			const categoryTree = this.$store.getters[STORE_GETTER.CATEGORY_MODEL]?.categoryTree;

			const categoryNode = categoryHelper.findNode(category.categoryId, categoryTree); // FP-CT

			console.log('FP: category: searchCategorySelected', categoryNode);

			if (!category) {
				console.log('FP: searchCategorySelected hittade ingen category, ', category);

				return;
			}

			this.searchProductConfig.brand = null;
			this.searchProductConfig.mc = null;
			this.searchProductConfig.year = null;
			

			this.searchProductConfig.manufactor = null;
			this.searchProductConfig.category = categoryNode;

			this.searchProductConfig.searchPhrase = '';
			this.searchProductConfig.productGroupKey = null
			this.filterInput = '-';

			//this.hideAllPageMenu()
			//this.showProductList()
		},



		searchManufactorSelected(manufactor) {
			//alert("searchManufactorSelected")

			console.log('FP: manufactor: ', manufactor);

			this.searchProductConfig.brand = null;
			this.searchProductConfig.mc = null;
			this.searchProductConfig.year = null;


			this.searchProductConfig.manufactor = manufactor;
			this.searchProductConfig.category = null;

			this.searchProductConfig.searchPhrase = '';
			this.searchProductConfig.productGroupKey = null
			this.filterInput = '-';

			this.hideAllPageMenu()
			this.showProductList()
		},

		searchManufactorSelectedWithoutNavigation(manufactor) { // FP: Se ovan

			console.log('FP: manufactor: ', manufactor);

			this.searchProductConfig.brand = null;
			this.searchProductConfig.mc = null;
			this.searchProductConfig.year = null;


			this.searchProductConfig.manufactor = manufactor;
			this.searchProductConfig.category = null;

			this.searchProductConfig.searchPhrase = '';
			this.searchProductConfig.productGroupKey = null
			this.filterInput = '-';

			//this.hideAllPageMenu()
			//this.showProductList()
		},

		resetSearchProductConfig(productGroupKey){

			console.log('FP: search resetSearchProductConfig: ');

			this.searchProductConfig.brand = null;
			this.searchProductConfig.mc = null;
			this.searchProductConfig.year = null;


			this.searchProductConfig.manufactor = null;
			this.searchProductConfig.category = null;

			this.searchProductConfig.searchPhrase = '';
			if (productGroupKey){
				this.searchProductConfig.productGroupKey = productGroupKey
			}else{
				this.searchProductConfig.productGroupKey = null
			}
			

			//this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, this.searchProductConfig)

			this.filterInput = '';

			if (typeof this.hideAllPageMenu === "function"){
				this.hideAllPageMenu()
			}
			
			
			// anropa rebuild och create-model efter denna

		},



		/*hideAllPageMenu(){
			console.log("FP: hideAllPageMenu")
		},*/

		showProductList(){ // överlagra för att komma till produktsidan
			console.log('FP: productSearchMixin.showProductList()');
			
		},



	},
	beforeUnmount() {
		clearTimeout(this.backspaceSearchTimer)
	}
}



